'use strict';

var jsonld = require('jsonld');
var helper = require('../../helper');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var jsonld__namespace = /*#__PURE__*/_interopNamespace(jsonld);

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const assertCredentialStatus = /* @__PURE__ */ __name((cs, mode = "verify") => {
  const { id, type } = cs;
  if (id) {
    helper._validateUriId({
      id,
      propertyName: "credentialStatus.id"
    });
  }
  if (!type) {
    throw new Error('"credentialStatus" must include a type.');
  }
  helper._checkCredentialStatus(cs, mode);
}, "assertCredentialStatus");
const assertCredentialStatuses = /* @__PURE__ */ __name((credential, mode = "verify") => {
  const cses = jsonld__namespace.getValues(credential, "credentialStatus");
  cses.forEach((cs) => assertCredentialStatus(cs, mode));
  if (cses.some((cs) => cs?.type === "TransferableRecords") && credential?.credentialStatus?.type !== "TransferableRecords") {
    throw new Error('"credentialStatus" TransferableRecords must be the only credential status and must be an object.');
  }
}, "assertCredentialStatuses");

exports.assertCredentialStatus = assertCredentialStatus;
exports.assertCredentialStatuses = assertCredentialStatuses;
